import { createSlice } from "@reduxjs/toolkit";

const bundle = createSlice({
  name: "bundle",
  initialState: {
    data: [],
    errorMessage: "",
    page: 0,
    itemsPerPage: 10,
    pagination: "",
  },

  reducers: {
    setBundle(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { setBundle } = bundle.actions;
export default bundle.reducer;
